import { Box, Txt, useBoolean } from '@stenajs-webui/core';
import { type ButtonSize, FlatButton } from '@stenajs-webui/elements';
import { type FC, useCallback } from 'react';
import { type TrackerCategory, trackEvent } from '../../common/tracking/trackerService';
import { FreightPortalControlledPopover } from '../popover/FreightPortalControlledPopover';
import type { Placement } from '../popover/FreightPortalPopover';
import { PopoverBody } from '../popover/PopoverBody';
import { PopoverTitle } from '../popover/PopoverTitle';

export interface CalculatePriceErrorsProps {
  buttonSize?: ButtonSize;
  errors: string[];
  placement?: Placement;
  trackerCategory: TrackerCategory;
}

export const CalculatePriceErrors: FC<CalculatePriceErrorsProps> = ({
  errors,
  trackerCategory,
  placement,
  buttonSize,
}) => {
  const [visible, open, close] = useBoolean(false);

  const onOpen = useCallback(() => {
    open();
    trackEvent({ category: trackerCategory, action: 'Show error' });
  }, [open, trackerCategory]);

  return (
    <FreightPortalControlledPopover
      renderTrigger={props => (
        <FlatButton size={buttonSize} onClick={onOpen} label={'Price unavailable'} {...props} />
      )}
      onRequestClose={close}
      open={visible}
      placement={placement}
    >
      <Box maxWidth={500}>
        <PopoverTitle text={'Price unavailable'} onClose={close} />
        <PopoverBody gap={2}>
          {errors.map(error => (
            <Txt key={error}>{error}</Txt>
          ))}
        </PopoverBody>
      </Box>
    </FreightPortalControlledPopover>
  );
};
